import React from "react";
import { FilterMultiselectOption } from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { VStack } from "@design-system/VStack/VStack";
import { BaseFilterProps } from "../../lib";
import { TriStateBooleanFilter } from "../TriStateBooleanFilter/TriStateBooleanFilter";
import styles from "./TaskDependenciesFilter.module.scss";

const hasBlockedByOption: FilterMultiselectOption = {
    value: "has_blocked_by",
    label: "Has blocked by",
    searchableLabel: "has blocked by",
};
const noBlockedByOption: FilterMultiselectOption = {
    value: "no_blocked_by",
    label: "Does not have blocked by",
    searchableLabel: "does not have blocked by",
};

const hasBlockingOption: FilterMultiselectOption = {
    value: "has_blocking",
    label: "Has blocking",
    searchableLabel: "has blocking",
};
const noBlockingOption: FilterMultiselectOption = {
    value: "no_blocking",
    label: "Does not have blocking",
    searchableLabel: "does not have blocking",
};

const hasRelatedOption: FilterMultiselectOption = {
    value: "has_related",
    label: "Has related",
    searchableLabel: "has related",
};
const noRelatedOption: FilterMultiselectOption = {
    value: "no_related",
    label: "Does not have related",
    searchableLabel: "does not have related",
};

export const TaskDependenciesFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <VStack>
        <div className={styles.section}>
            <p className={styles.sectionLabel}>Blocked by</p>
            <TriStateBooleanFilter
                value={filters.hasBlockedBy}
                onChange={(hasBlockedBy) => onChange({ hasBlockedBy })}
                trueOption={hasBlockedByOption}
                falseOption={noBlockedByOption}
                name="hasBlockedBy"
            />
        </div>
        <div className={styles.section}>
            <p className={styles.sectionLabel}>Blocking</p>
            <TriStateBooleanFilter
                value={filters.hasBlocking}
                onChange={(hasBlocking) => onChange({ hasBlocking })}
                trueOption={hasBlockingOption}
                falseOption={noBlockingOption}
                name="hasBlocking"
            />
        </div>
        <div className={styles.section}>
            <p className={styles.sectionLabel}>Related</p>
            <TriStateBooleanFilter
                value={filters.hasRelated}
                onChange={(hasRelated) => onChange({ hasRelated })}
                trueOption={hasRelatedOption}
                falseOption={noRelatedOption}
                name="hasRelated"
            />
        </div>
    </VStack>
);
